import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import '../styles/NotFound.css';
import SEO from '../components/SEO';

const NotFound = () => {
  
  return (
    <>
    <SEO 
  title="404 - Stranica nije pronađena"
  description="Tražena stranica ne postoji."
/>
    <main className="not-found-page">
      <div className="not-found-content">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="not-found-label">Greška 404</span>
          <h1>Stranica nije pronađena</h1>
          <p>Izgleda da ste zalutali. Stranica koju tražite ne postoji ili je premeštena.</p>
          
          <div className="not-found-actions">
            <Link to="/" className="btn-gold">
              <FiHome /> Početna
            </Link>
            <button className="btn-outline" onClick={() => window.history.back()}>
              <FiArrowLeft /> Nazad
            </button>
          </div>
        </motion.div>
      </div>
    </main>
    </>
  );
};

export default NotFound;